'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'hand-wave';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e1a7';
var svgPathData = 'M376.2 67.4L375 58.9c-2.5-17.6-16.3-31.4-33.9-33.9l-8.5-1.2c-13.1-1.9-22.2-14-20.4-27.2s14-22.2 27.2-20.4l8.5 1.2c38.7 5.5 69.1 36 74.7 74.7l1.2 8.5c1.9 13.1-7.2 25.3-20.4 27.2s-25.3-7.2-27.2-20.4zM112 68.7c17.9-17.9 43.8-23 66.2-15.2 3.1-6.8 7.4-13.1 13-18.7 25-25 65.5-25 90.5 0L400 153 400 147.9c0-35.3 28.7-64 64-64s64 28.7 64 64l0 157.7c0 1.6 0 3.1-.1 4.7 0 .6 .1 1.1 .1 1.7 0 109.9-88.7 199.2-198.5 200l-.5 0-7.6 0c-53 0-103.9-21.1-141.4-58.6L66.7 340.2c-25-25-25-65.5 0-90.5 3.9-3.9 8.2-7.2 12.7-9.9l-1.4-1.4c-25-25-25-65.5 0-90.5 5.6-5.6 11.9-9.9 18.7-13-7.7-22.4-2.7-48.3 15.2-66.2zm79.3 56.7l-.1-.1-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l22.5 22.5 .1 .1 96.2 96.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-96.1-96.1-.1-.1c-6.2-6.2-16.4-6.2-22.6 0-6.2 6.2-6.2 16.4 0 22.6l39.5 39.5 .1 .1 56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-50.8-50.8-.1-.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L213.9 419.5C242.4 448 281.1 464 321.4 464l7.5 0c82.8-.5 149.9-67.1 151.1-149.8-.1-1-.1-2.1-.1-3.1 .1-1.8 .1-3.6 .1-5.5l0-157.7c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 63.1c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2L247.8 68.7c-6.2-6.2-16.4-6.2-22.6 0-6.2 6.2-6.2 16.3-.1 22.6l96.2 96.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-96.1-96.1zM28.6 376.2c13.1-1.9 25.3 7.2 27.2 20.4l1.2 8.5c2.5 17.6 16.3 31.4 33.9 33.9l8.5 1.2c13.1 1.9 22.2 14 20.4 27.2s-14 22.2-27.2 20.4l-8.5-1.2C45.4 481 15 450.6 9.5 411.9l-1.2-8.5c-1.9-13.1 7.2-25.3 20.4-27.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHandWave = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;